/**
 * Dagobah-Web-API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.8.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The CreateTablesFromGoldStandardRequest model module.
 * @module model/CreateTablesFromGoldStandardRequest
 * @version 2.8.0
 */
class CreateTablesFromGoldStandardRequest {
    /**
     * Constructs a new <code>CreateTablesFromGoldStandardRequest</code>.
     * @alias module:model/CreateTablesFromGoldStandardRequest
     * @param name {String} 
     */
    constructor(name) { 
        
        CreateTablesFromGoldStandardRequest.initialize(this, name);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, name) { 
        obj['name'] = name;
    }

    /**
     * Constructs a <code>CreateTablesFromGoldStandardRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/CreateTablesFromGoldStandardRequest} obj Optional instance to populate.
     * @return {module:model/CreateTablesFromGoldStandardRequest} The populated <code>CreateTablesFromGoldStandardRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new CreateTablesFromGoldStandardRequest();

            if (data.hasOwnProperty('name')) {
                obj['name'] = ApiClient.convertToType(data['name'], 'String');
            }
            if (data.hasOwnProperty('projectCollection')) {
                obj['projectCollection'] = ApiClient.convertToType(data['projectCollection'], 'String');
            }
            if (data.hasOwnProperty('files')) {
                obj['files'] = ApiClient.convertToType(data['files'], ['String']);
            }
        }
        return obj;
    }


}

/**
 * @member {String} name
 */
CreateTablesFromGoldStandardRequest.prototype['name'] = undefined;

/**
 * @member {String} projectCollection
 */
CreateTablesFromGoldStandardRequest.prototype['projectCollection'] = undefined;

/**
 * @member {Array.<String>} files
 */
CreateTablesFromGoldStandardRequest.prototype['files'] = undefined;






export default CreateTablesFromGoldStandardRequest;

